<script lang="ts" setup>
import type { DocumentGroupsItem } from '~/pages/insurance/detail.vue'
export interface WidgetDocumentsProps {
    data: Array<DocumentGroupsItem>
}

const props = defineProps<WidgetDocumentsProps>()
const { $t } = useNuxtApp()
const documentsEmpty = computed<boolean>(() => {
    return props.data.reduce(
        (acc, curr) => acc && curr.documents.length === 0,
        true
    )
})
const title = $t('Dokumenty na stiahnutie')
</script>
<template>
  <section>
    <Box
      color="gray"
      data-cy="widget_documents"
    >
      <Tracker :data="{ position: title }">
        <BoxHeader
          :heading="title"
          heading-level="h2"
        />
        <PagesDocumentsEmpty v-if="documentsEmpty" />
        <Accordion v-else>
          <template
            v-for="(group, groupIndex) in props.data"
            :key="`insurace-document-${groupIndex}`"
          >
            <AccordionItem
              v-if="group.documents.length > 0"
              :is-open="groupIndex === 0"
              color="secondary"
              :btn-text="group.title"
              :btn-index="0"
            >
              <DocumentsTable :data="group.documents" />
            </AccordionItem>
          </template>
        </Accordion>
      </Tracker>
    </Box>
  </section>
</template>
